module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "toShow": _vm.toShow,
      "scrollable": "",
      "persistent": "",
      "full-width": "",
      "max-width": "933"
    },
    on: {
      "update:toShow": function($event) {
        _vm.toShow = $event
      },
      "update:to-show": function($event) {
        _vm.toShow = $event
      }
    },
    model: {
      value: (_vm.interf),
      callback: function($$v) {
        _vm.interf = $$v
      },
      expression: "interf"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "titulo-detalhes pl-12  mt-12 mb-12 headline"
  }, [_vm._v("Manual CondoPlaza")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeManual
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "pl-12 pr-12",
    staticStyle: {
      "background-color": "#f5f5f5"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('object', {
    staticStyle: {
      "min-height": "600px"
    },
    attrs: {
      "data": _vm.urlPdf,
      "width": "100%",
      "height": "100%",
      "type": "application/pdf"
    }
  }, [_c('embed', {
    attrs: {
      "src": _vm.urlPdf,
      "type": "application/pdf"
    }
  })])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-330e9c8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/manual/manual.vue
// module id = 742
// module chunks = 6